export default __webpack_public_path__ + "static/media/kitchen5-afterA-1440w.49da8551.avif";